<div class="register-result-page-container">
  <app-register-result class="z-index--1"></app-register-result>
  <app-circles-background class="circle-background"></app-circles-background>
</div>
